export default __webpack_public_path__ + "static/media/4.80da5802.jpg";